import { render, staticRenderFns } from "./ListaTrasladoCartaPorte.vue?vue&type=template&id=434585b7&"
import script from "./ListaTrasladoCartaPorte.vue?vue&type=script&lang=js&"
export * from "./ListaTrasladoCartaPorte.vue?vue&type=script&lang=js&"
import style0 from "./ListaTrasladoCartaPorte.vue?vue&type=style&index=0&id=434585b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports